export default __webpack_public_path__ + "static/media/Ver.5b877e1c.svg";